import { apiFetch, ApiBaseUrl } from "./fetch";

export default class ApiConnectorActions {
  static getActions(appId) {
    return apiFetch(`${ApiBaseUrl}apps/${appId}/connector_actions`);
  }

  static updateAction(appId, actionId, action) {
    return apiFetch(`${ApiBaseUrl}apps/${appId}/connector_actions/${actionId}`, {
      method: "PUT",
      body: { connector_action: action },
    });
  }

  static createAction(appId, action) {
    return apiFetch(`${ApiBaseUrl}apps/${appId}/connector_actions`, {
      method: "POST",
      body: { connector_action: action },
    });
  }

  static async deleteAction(appId, actionId) {
    return apiFetch(`${ApiBaseUrl}apps/${appId}/connector_actions/${actionId}`, {
      method: "DELETE",
    }).then(_ => actionId);
  }
}
